import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
    ApiAdapterPromise,
    ApiAdapterRequestConfig,
    ApiResponse,
    rulesEngineSelectors,
    Race,
    RuleData, RaceDefinitionContract,
} from '@dndbeyond/character-rules-engine/es';

import { modalActions } from '../../../../Shared/actions';
import { apiCreatorSelectors } from '../../../../Shared/selectors';
import { builderActions } from '../../../actions';
import Page from '../../../components/Page';
import PageBody from '../../../components/PageBody';
import PageHeader from '../../../components/PageHeader';
import RaceChooser from '../../../components/RaceChooser';
import RaceDisplaySimple from '../../../components/RaceDisplaySimple';
import { navigationConfig } from '../../../config';
import { RouteKey } from '../../../constants/navigation';
import { BuilderAppState } from '../../../typings';
import ConnectedBuilderPage from '../ConnectedBuilderPage';

interface Props {
    loadRaces: (additionalConfig?: Partial<ApiAdapterRequestConfig>) => ApiAdapterPromise<ApiResponse<Array<RaceDefinitionContract>>>;
    race: Race | null;
    ruleData: RuleData;
    characterId: number;
}
const RaceChoose: React.FC<Props> = ({
    loadRaces,
    race,
    ruleData,
    characterId
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
        <Page>
            <PageBody>
                <PageHeader>{`${race ? 'Change' : 'Choose a'} Race`}</PageHeader>
                {race &&
                    <RaceDisplaySimple
                        race={race}
                        onRequestAction={() =>
                            navigate(navigationConfig.getRouteDefPath(RouteKey.RACE_MANAGE).replace(":characterId", characterId))
                        }
                        actionText="Keep Race"
                        headingText="Current Race"
                        ruleData={ruleData}
                    />
                }
                {race && <PageHeader>Select New Race</PageHeader>}
                <RaceChooser
                    loadRaces={loadRaces}
                    onRaceSelected={(race) => {
                        dispatch(builderActions.confirmRaceSet(race));
                        dispatch(modalActions.open('race-choose-confirm'));
                        window.scrollTo(0, 0);
                    }}
                    currentRace={race}
                    ruleData={ruleData}
                />
            </PageBody>
        </Page>
    );

}

export default ConnectedBuilderPage(RaceChoose, RouteKey.RACE_CHOOSE, (state: BuilderAppState) => {
    return {
        loadRaces: apiCreatorSelectors.makeLoadAvailableRaces(state),
        race: rulesEngineSelectors.getRace(state),
        ruleData: rulesEngineSelectors.getRuleData(state),
        characterId: rulesEngineSelectors.getId(state),
    };
});
